
import {contentRoot} from '../config.js';


var initialState =
{
    image:contentRoot+"img/placeholder.png",
    isLoading: false,
    isUpdatePending: false
}


const materialImage = (state = initialState, action) => {
  switch (action.type) {
    case 'MATERIALIMAGE_UPDATE_COMPLETE':
      return Object.assign({}, state, {
          image: action.canvas.toDataURL(),
          previousImage: state.image,
          isLoading:false
      })
    case 'MATERIALIMAGE_UPDATE_STARTED':
      return Object.assign({}, state, {
          isLoading: true,
          isUpdatePending: false,
          previousImage:state.image
      })
      case 'SET_UPDATEPENDING':
          return Object.assign({}, state, {
              isUpdatePending: action.isUpdatePending
          })

     default:
      return state;
  }
}
export default materialImage;
